import { ScreenContext } from '@hb/react'
import React, { PropsWithChildren, ReactElement, Suspense, useContext, useMemo } from 'react'
import { useFile, UseFileData } from '../../../hooks/backend/storage/downloadFile'
import { DefaultModal } from '../DefaultModal'

const PdfView = React.lazy(() => import('../../PdfView').then(m => ({ default: m.PdfView })))

interface PdfViewModalProps {
  isOpen: boolean
  onClose: () => void
  url?: string
  header: string | ReactElement
  onAfterRegenerate?: () => void
}

interface StoragePathPdfViewModalProps {
  isOpen: boolean
  onClose: () => void
  storagePath: string
  header: string | ReactElement
}

export const PdfViewModal = ({
  url,
  header,
  children,
  onAfterRegenerate,
  ...modalProps
}: PropsWithChildren<PdfViewModalProps>) => {
  const screen = useContext(ScreenContext)

  const { width, height } = useMemo(() => {
    const w = Math.min(screen.width, 1000)
    return { width: w, height: Math.min(screen.height - 50, w * 1.4143) }
  }, [screen])
  return (
    <DefaultModal
      scrollBehavior="inside"
      header={header}
      {...modalProps}
      bodyProps={{
        padding: 0,
        overflow: 'hidden',
        width: `${width}px`,
        maxHeight: `${height}px`,
        display: 'flex',
        flexFlow: 'column',
        height: `${height}px`,
      }}
      contentProps={{
        overflow: 'hidden',
        minW: 0,
        margin: 'auto',
        maxW: width,
        height: `${height}px`,
        maxH: `${height}px`,
        width: 'auto',
      }}
      render={() => (
        <Suspense>
          <PdfView
            onClose={modalProps.onClose}
            url={url}
            width={width}
            height={height}
            onAfterRegenerate={onAfterRegenerate}>
            {children}
          </PdfView>
        </Suspense>
      )}
    />
  )
}

export const StoragePathPdfViewModal = ({
  storagePath,
  ...modalProps
}: StoragePathPdfViewModalProps) => {
  const useFileArgs = useMemo<UseFileData>(
    () => ({
      path: storagePath,
      pathLoading: false,
    }),
    [storagePath],
  )
  const { url, fetchFile } = useFile(useFileArgs)
  return <PdfViewModal url={url} onAfterRegenerate={fetchFile} {...modalProps} />
}
